// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__-3IPa","rootSmall":"AddTileButton_rootSmall__1ag9d"};